/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>


module DealerwareWebContent {

    "use strict";

    import ILocation = DealerwareWebServices.ILocation;

    export class LocationController {

        public static $inject : string[ ] = [
            '$scope',
            '$state',
            '$stateParams',
            '$dealerwareNotification',
            '$dealerwareLoading',
            '$q',
            '$controller',
            'DataUtils',
            'LocationFactory',
            'LocationPersistenceService',
            'CurrentLocation',
            'reverseRouteShortcuts',
            '$dealerwareInternationalizationData',
        ];

        public location  : ILocation;
        public dataUtils : any;

        public settingsLoaded   : boolean = false;
        public doLoadOpenDays   : boolean = false;
        public labels: any;


        constructor(
            public $scope                       : any,
            public $state                       : any,
            public $stateParams                 : any,
            public $dealerwareNotification      : any,
            public $dealerwareLoading           : any,
            public $q                           : any,
            public $controller                  : any,
            public DataUtils                    : any,
            public LocationFactory              : any,
            public LocationPersistenceService   : any,
            public CurrentLocation              : any,
            public reverseRouteShortcuts        : any,
            public $dealerwareInternationalizationData: any,
        ) {

            this.dataUtils = this.DataUtils.getInstance();

            this.location =  this.LocationFactory.getInstance();

            this.getLabels('settings');
            this.load();
        }

        public getLabels(module: string): void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public load () : void  {

            // Load into Location object ourselves...
            //
            if (! this.dataUtils.isBlank(this.$stateParams.locationId)) {

                var loader = this.$dealerwareLoading.show ('Loading...');

                this.location.load (this.$stateParams.locationId)
                    .then ( ( ) => {
                        return loader.close();
                    })
                    .then ( ( ) => {

                        var currentState = this.reverseRouteShortcuts[this.$state.current.name];

                        if (currentState === 'locationDetails') {
                            return this.loadSettings();
                        }
                        else if (currentState === 'locationDaysOfOperation') {
                            this.doLoadOpenDays = true;
                        }

                        return this.$q.when();
                    })
                    .then ( ( ) => {
                        loader.close();
                    })
                    .catch ( (response : any) => {
                        loader.close();
                        this.$dealerwareNotification.apiError(response);
                    });
            }
            // ... or it's been loaded from elsewhere, elsewhen.
            //
            else {
                Object.keys(this.location).forEach( ( key: string ) => {
                    var locationDataPoint = this.CurrentLocation._location
                        && this.CurrentLocation._location.data
                        && this.CurrentLocation._location.data[key];

                    if ( typeof locationDataPoint === 'string'
                         || typeof locationDataPoint === 'number'
                       ) {
                        (<any>this.location)[key] = locationDataPoint;
                    }
                });
            }
        }

        public loadSettings () : ng.IPromise<any> {

            if (this.settingsLoaded) {
                return this.$q.when();
            }

            var loader = this.$dealerwareLoading.show ('Loading...');

            return this.location.loadSettings (this.$stateParams.locationId)
                .then ( (locationSettings : ILocation) => {
                    angular.extend(this.location, locationSettings);
                    this.location.settings.custom_minimum_age = this.location.settings.minimum_age !== 21;
                    loader.close();
                    this.settingsLoaded = true;
                })
                .catch ( (response : any) => {
                    loader.close();
                    this.$dealerwareNotification.apiError(response);
                });
        }

        public loadMap() : void {
            if (this.location.showMap === undefined) {
                this.location.showMap = true;
            }
        }

        public isSummaryPage () : boolean {
            return this.$state.current.url.match(/summary$/) !== null;
        }

        public isAddressPage () : boolean {
            return this.$state.current.url.match(/address$/) !== null;
        }

        public isDetailsPage () : boolean {
            return this.$state.current.url.match(/details$/) !== null;
        }

        public isDaysOfOperationPage () : boolean {
            return this.$state.current.url.match(/days_of_operation$/) !== null;
        }

        public transitionToSummary () : void {
            this.LocationPersistenceService.location = this.location;
            this.$state.go ('root.private.application.locations.location.summary');
        }

        public transitionToAddress () : void {
            this.LocationPersistenceService.location = this.location;
            this.$state.go ('root.private.application.locations.location.address');
        }

        public transitionToDetails () : void {
            this.LocationPersistenceService.location = this.location;
            this.$state.go ('root.private.application.locations.location.details');
        }

        public transitionToDaysOfOperation () : void {
            this.LocationPersistenceService.location = this.location;
            this.$state.go ('root.private.application.locations.location.daysOfOperation');
        }
    }

    getDealerwareWebContentModule ()
        .controller ('LocationController', LocationController);


    export class LocationPersistenceService {

        public _location : ILocation;

        public get location () : ILocation {
            return this._location;
        }

        public set location (location : ILocation) {
            this._location = location;
        }

        public clear () : void {
            this.location = undefined;
        }
    }

    getDealerwareWebContentModule()
        .service ('LocationPersistenceService', LocationPersistenceService);
}
